import { render, staticRenderFns } from "./AcquisitionReserved.html?vue&type=template&id=6b92e4ce&"
import script from "./AcquisitionReserved.js?vue&type=script&lang=js&"
export * from "./AcquisitionReserved.js?vue&type=script&lang=js&"
import style0 from "./AcquisitionReserved.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports